import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { deepPurple } from '@material-ui/core/colors';
import { Menu, MenuItem, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { useMsal, useAccount } from '@azure/msal-react';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
  avatar: {
    height: 25,
    width: 25,
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  font: {
    marginLeft: theme.spacing(2),
    whiteSpace: 'nowrap'
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
  }
}));


const UserAvatar = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <div className={classes.avatarContainer} onClick={handleClick}>
        <Avatar className={classes.avatar}></Avatar>
        <Typography className={classes.font}>{account.idTokenClaims.name}</Typography>
      </div>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={() => instance.logoutRedirect()}>{t('Profile')}</MenuItem>
        <MenuItem onClick={() => instance.logoutRedirect()}>{t('Settings')}</MenuItem>
        <Divider />
        <MenuItem onClick={() => instance.logoutRedirect()}>{t('logout')}</MenuItem>
      </Menu>
    </div>

  );
};


export default UserAvatar;
